const { m } = require('minthril');
const { ProductCard } = require('../../productCard');
const { NotFoundPage } = require('../notFound');

function CollectionsPage() {
  return {
    view: ({ attrs }) => {
      const collections = getCollectionPresentations(attrs.collections, attrs.products);

      return m('section.collections-page',
        m('header.collections-page__intro',
          m('p.products__eyebrow', 'Browse by platform'),
          m('h1.products__heading', 'Collections'),
          m('p.products__description', 'Explore parts grouped by the cars and platforms they were made for.'),
          m('p.collections-page__browse-mode', 'Prefer to browse all parts? ',
            m('a', { href: '/products' }, 'Go to all parts →')
          )
        ),
        m('div.collections-page__grid', collections.map(presentation =>
          m(CollectionCard, presentation)
        ))
      );
    }
  };
}

function CollectionCard() {
  return {
    view: ({ attrs: { collection, productCount, imageUrl } }) => m('a.collection-card.product-card.product-card--curated', {
      href: `/collections/${collection.handle}`
    },
    m('div.product-card__image', imageUrl
      ? m('img', { src: imageUrl, alt: collection.title, loading: 'lazy' })
      : m('img.collection-card__fallback', {
        src: '/images/mec-logo-basic-small.webp',
        alt: 'Mid Engine Co',
        loading: 'lazy'
      })
    ),
    m('div.product-card__content',
      m('p.product-card__type', 'Collection'),
      m('h2.product-card__title', collection.title),
      m('p.collection-card__count', `${productCount} part${productCount === 1 ? '' : 's'}`),
      m('span.collection-card__link', 'Explore collection →')
    ))
  };
}

function CollectionPage() {
  return {
    view: ({ attrs }) => {
      const presentation = getCollectionPresentations(attrs.collections, attrs.products)
        .find(item => item.collection.handle === attrs.handle);

      if (!presentation) return m(NotFoundPage);

      const { collection, imageUrl } = presentation;
      const collectionProductIds = new Set(collection.products.nodes.map(product => product.id));
      const products = attrs.products.filter(product => collectionProductIds.has(product.id));

      return m('section.collection-page',
        m('a.collection-page__back', { href: '/collections' }, '← All collections'),
        m('header.collection-page__hero', { style: imageBackground(imageUrl) },
          m('p.products__eyebrow', `${products.length} part${products.length === 1 ? '' : 's'}`),
          m('h1.products__heading', collection.title)
        ),
        products.length
          ? m('div.products__grid products__grid--list', products.map(product => m(ProductCard, {
            key: product.id,
            product,
            onAdd: attrs.onAdd,
            cartQuantity: attrs.cartQuantities[product.variants.nodes[0]?.id] || 0,
            variant: 'list'
          })))
          : m('p.collection-page__empty', 'There are no parts in this collection yet.')
      );
    }
  };
}

function getCollectionPresentations(collections, products) {
  const orderedCollections = collections
    .filter(collection => collection.title.toLowerCase() !== 'home page')
    .map(collection => ({
      collection,
      productCount: collection.products.nodes.length
    }))
    .filter(entry => entry.productCount > 0)
    .sort((first, second) => second.productCount - first.productCount);
  const claimedProductIds = new Set();

  return orderedCollections.map(entry => {
    const memberIds = new Set(entry.collection.products.nodes.map(product => product.id));
    const availableProducts = products.filter(product =>
      memberIds.has(product.id) && product.featuredImage?.url
    );
    const product = availableProducts.find(item => !claimedProductIds.has(item.id)) || availableProducts[0];

    if (product) claimedProductIds.add(product.id);

    return {
      ...entry,
      imageUrl: product?.featuredImage?.url || null
    };
  });
}

function imageBackground(imageUrl) {
  if (!imageUrl) return undefined;

  return {
    backgroundImage: `linear-gradient(180deg, rgba(8, 8, 8, .15), rgba(8, 8, 8, .88)), url("${imageUrl}")`
  };
}

module.exports = { CollectionsPage, CollectionPage };
